import { gql, useMutation } from '@apollo/client';
import { Pda } from './components/Pda';
import { Header } from './components/Header';
import { ArrivalRelatedScanComponent, HandleScanEventResult } from './components/ArrivalRelatedScanComponent';
import { showBarCodeError, showTrackingNumberError } from '../../utils/BarCodeUtil';
import { isTrackingNumber } from '../../utils/BarCodeUtil';
import { t } from '../../i18n';

const HANDLE_RETURN_SCAN_EVENT = gql`
   mutation HandleWhsReturnScanEvent($barCode: String!) {
     success: handleWhsReturnScanEvent(barCode: $barCode)
   }
`;

const PageBody = () => {
    const [handleReturnScanEvent] = useMutation<HandleScanEventResult>(HANDLE_RETURN_SCAN_EVENT);

    const handleScanEvent = async (barCode: string): Promise<HandleScanEventResult> => {
        if (!isTrackingNumber(barCode)) {
            showTrackingNumberError(barCode);
            return {success: false};
        }
        const { data } = await handleReturnScanEvent({ variables: { barCode } });
        return { success: data?.success || false };
    };
    return (
        <ArrivalRelatedScanComponent
         value1Placeholder={t('pda.pages.return.trackingNO')}
         value1ColumnTitle={t('pda.pages.return.trackingNO')}
         handleScanEvent={handleScanEvent} />
    );
}

export default function ReturnPage() {
    return (
        <div className="w-full h-full flex flex-col gap-2 p-2">
            <Header title={t('pda.pages.return.returnScan')}/>
            <Pda/>
            <PageBody/>
        </div>
    );
} 